export default __webpack_public_path__ + "static/media/html5.c1bb84e0.svg";